// extracted by mini-css-extract-plugin
export var createdDate = "_mn-1";
export var divider = "_mn-2";
export var headerDivider = "_mn-3";
export var messagesCard = "_mn-0";
export var messagesContainer = "_mn-7";
export var messagesContainerWrapper = "_mn-4";
export var pointerCapturingButtonBoxes = "_mn-a";
export var showLeftPanelButton = "_mn-9";
export var showMoreButton = "_mn-c";
export var showMoreButtonContainer = "_mn-b";
export var summaryTitle = "_mn-6";
export var systemMessageCardWrapper = "_mn-d";
export var topButtons = "_mn-8";
export var withPadding = "_mn-5";